var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component',_vm._b({class:[
    'lbz-button',
    _vm.type && ("lbz-button--" + _vm.type),
    _vm.color && ("lbz-button--" + _vm.color),
    {
      'lbz-is-full-width': _vm.fullWidth,
      'lbz-is-dense': _vm.cisDense,
      'lbz-is-unelevated': _vm.type === 'contained' && _vm.unelevated,
      'lbz-is-disabled': _vm.disabled
    }
  ],on:{"click":function($event){!_vm.disabled && _vm.$emit('click', $event)}}},'component',_vm.cgetAttrs,false),[(_vm.icon || _vm.$slots.icon)?_c('lbz-icon',{staticClass:"lbz-button__icon"},[(_vm.icon)?[_vm._v(_vm._s(_vm.icon))]:_vm._t("icon")],2):_vm._e(),_c('span',{staticClass:"lbz-button__label"},[_vm._t("default")],2),(!_vm.disabled)?_c('lbz-state',_vm._b({},'lbz-state',_vm.cgetStateAttrs,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }